import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Globals } from '../../ressources/variables/globals';
import { CommonFunctionsService } from '../Global/commonFunctions.service';
import { GracenoteSearch } from '../../ressources/types/gracenoteSearch';
import { SpotifySearch } from '../../ressources/types/spotifySearch';
import { DeezerSearch } from '../../ressources/types/deezerSearch';
import { MusicbrainzSearch } from '../../ressources/types/musicbrainzSearch';
import { MetadataSearch } from '../../ressources/types/metadataSearch';

import { Musiques } from '../../ressources/types/musiques';
import { MusiquesMix } from '../../ressources/types/musiquesMix';

import slugify from 'slugify';

@Injectable()
export class MusicsDataService {

  websiteRacine = Globals.websiteRacine;
  serverEndpoint = Globals.serverEndpoint;

  constructor(private http: HttpClient,
              private CF: CommonFunctionsService) {}

  gracenoteSearchTrack(performer: string, title: string, album: string): Promise<{status: boolean, result: GracenoteSearch}> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('performer', performer)
      .set('title', title)
      .set('album', album);
    return new Promise((resolve) => {
      this.http.post<GracenoteSearch>(this.serverEndpoint + '/api/gracenoteSearchTrack',
        body.toString(), {headers}).toPromise()
        .then(connection => {
          if (!connection || !connection[0] || (connection[0].constructor === Object && Object.keys(connection[0]).length === 0)) {
            resolve({
              status: false,
              result: connection[0]
            });
          } else {
            resolve({
              status: true,
              result: connection[0]
            });
          }
        }).catch(err => {
          resolve({
            status: true,
            result: err
          });
        });
    });
  }

  spotifySearchTrack(performer: string, title: string, album: string): Promise<{status: boolean, result: SpotifySearch}> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('performer', performer)
      .set('title', title)
      .set('album', album);
    return new Promise((resolve) => {
      this.http.post<SpotifySearch>(this.serverEndpoint + '/api/spotifySearchTrack',
        body.toString(), {headers}).toPromise()
        .then(connection => {
          if (connection.constructor === Object && Object.keys(connection).length === 0) {
            resolve({
              status: false,
              result: connection
            });
          } else {
            resolve({
              status: true,
              result: connection
            });
          }
        }).catch(err => {
          resolve({
            status: true,
            result: err
          });
        });
    });
  }

  spotifySearchTrackByISRC(isrc: string|null): Promise<{status: boolean, result: SpotifySearch}> {
    console.log(isrc);
    if (!isrc) {
      return Promise.resolve({
        status: false,
        result: {}
      });
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('isrc', isrc);
    return new Promise((resolve) => {
      this.http.post<SpotifySearch>(this.serverEndpoint + '/api/spotifySearchTrackByISRC',
        body.toString(), {headers}).toPromise()
        .then(connection => {
          console.log(connection);
          if (connection.constructor === Object && Object.keys(connection).length === 0) {
            resolve({
              status: false,
              result: connection
            });
          } else {
            resolve({
              status: true,
              result: connection
            });
          }
        }).catch(err => {
          console.log(err);
          resolve({
            status: true,
            result: err
          });
        });
    });
  }

  deezerSearchTrack(performer: string, title: string, album: string): Promise<{status: boolean, result: DeezerSearch}> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('performer', performer)
      .set('title', title)
      .set('album', album);
    return new Promise((resolve) => {
      this.http.post<DeezerSearch>(this.serverEndpoint + '/api/deezerSearchTrack',
        body.toString(), {headers}).toPromise()
        .then(connection => {
          if (connection.constructor === Object && Object.keys(connection).length === 0) {
            resolve({
              status: false,
              result: connection
            });
          } else {
            resolve({
              status: true,
              result: connection
            });
          }
        }).catch(err => {
          resolve({
            status: true,
            result: err
          });
        });
    });
  }

  musicbrainzSearchTrack(performer: string, title: string, album: string, isrc: string|null): Promise<{status: boolean, result: MusicbrainzSearch}> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('performer', performer)
      .set('title', title)
      .set('album', album)
      .set('isrc', isrc || '');
    return new Promise((resolve) => {
      this.http.post<MusicbrainzSearch>(this.serverEndpoint + '/api/musicbrainzSearchTrack',
        body.toString(), {headers}).toPromise()
        .then(connection => {
          if (connection.constructor === Object && Object.keys(connection).length === 0) {
            resolve({
              status: false,
              result: connection
            });
          } else {
            resolve({
              status: true,
              result: connection
            });
          }
        }).catch(err => {
        resolve({
          status: true,
          result: err
        });
      });
    });
  }

  checkCurrentArtistPicture(performer: string): Promise<any> {
    const performerSlug = slugify(performer, {
      lower: true,
      strict: true,
      trim: true
    });
    return new Promise((resolve) => {
      this.http.head(this.websiteRacine + '/storage/winmedia/performers_thumbnail/' + performerSlug + '.jpg', { observe: 'response' }).toPromise()
        .then(response => {
          if (response.status === 200) {
            resolve(this.websiteRacine + '/storage/winmedia/performers_thumbnail/' + performerSlug + '.jpg');
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          resolve(null);
        });
    });
  }

  getWinmediaInstagram(performer: string): Promise<any> {
    return new Promise((resolve) => {
      this.http.get<any>(this.serverEndpoint + '/api/getWinmediaInstagram?performer=' + this.CF.escapeSpecialsURL(performer))
        .toPromise()
        .then(connection => {
          resolve(Array.isArray(connection) ? connection : []);
        }).catch(() => {
          resolve([]);
        });
    });
  }

  searchTrackMetadataServices(performer: string, title: string, album: string, isrc: string|null): Promise<MetadataSearch> {
    return new Promise((resolve) => {
      const deezerPromise = this.deezerSearchTrack(performer, title, album);
      const spotifyPromise = this.spotifySearchTrack(performer, title, album);
      const spotifyByIsrcPromise = this.spotifySearchTrackByISRC(isrc);
      const artistPicturePromise = this.checkCurrentArtistPicture(performer);
      const winmediaInstagramPromise = this.getWinmediaInstagram(performer);

      // MusicBrainz attend Spotify pour connaître l'ISRC à privilégier : celui déjà connu (tag/Deezer)
      // en premier, sinon celui que Spotify vient de retrouver pour ce morceau (2e recours, notamment
      // en relance manuelle où on ne repart plus de l'ancien ISRC — voir reloadMetadataWithReview).
      Promise.all([spotifyPromise, spotifyByIsrcPromise])
        .then(([spotifyResult, spotifyByIsrcResult]) => {
          const spotifyChosen = spotifyByIsrcResult.status ? spotifyByIsrcResult.result : spotifyResult.result;
          const foundIsrc = isrc || spotifyChosen?.candidates?.[0]?.track?.external_ids?.isrc || null;

          Promise.all([
            deezerPromise,
            this.musicbrainzSearchTrack(performer, title, album, foundIsrc),
            artistPicturePromise,
            winmediaInstagramPromise
          ]).then(([deezerResult, musicbrainzResult, artistPictureResult, winmediaInstagramResult]) => {
            resolve({
              gracenote: { status: false, result: {} },
              deezer: deezerResult,
              spotify: spotifyResult,
              spotifyByISRC: spotifyByIsrcResult,
              musicbrainz: musicbrainzResult,
              currentArtistPicture: artistPictureResult,
              winmediaInstagram: winmediaInstagramResult
            });
          });
        });
    });
  }

  searchTrackMetadata(performer: string, title: string, album: string, isrc: string|null): Promise<MetadataSearch> {
    return new Promise((resolve) => {
      this.searchTrackMetadataServices(performer, title, album, isrc)
        .then(results => {
          resolve(results);
        });
    });
  }

  tmdbSearchCover(search: string): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return new Promise((resolve, reject) => {
      this.http.get<any>(this.serverEndpoint + '/api/tmdbSearchCover?search=' + this.CF.escapeSpecialsURL(search), {headers}).toPromise()
        .then(results => {
          resolve(Array.isArray(results) ? results : []);
        }).catch(err => {
          reject(err);
        });
    });
  }

  discogsSearchCover(search: string): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return new Promise((resolve, reject) => {
      this.http.get<any>(this.serverEndpoint + '/api/discogsSearchCover?search=' + this.CF.escapeSpecialsURL(search), {headers}).toPromise()
        .then(connection => {
          if (connection.results) {
            resolve(connection.results);
          } else {
            resolve([]);
          }
        }).catch(err => {
          reject(err);
        });
    });
  }

  searchArtistPicture(search: string): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return new Promise((resolve, reject) => {
      this.http.get<any>(this.serverEndpoint + '/api/searchArtistPicture?search=' + this.CF.escapeSpecialsURL(search), {headers}).toPromise()
        .then(results => {
          resolve(results);
        }).catch(err => {
          reject(err);
        });
    });
  }

  searchArtistInstagram(search: string): Promise<{musicbrainz: any[], genius: any[]}> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return new Promise((resolve, reject) => {
      this.http.get<any>(this.serverEndpoint + '/api/searchArtistInstagram?search=' + this.CF.escapeSpecialsURL(search), {headers}).toPromise()
        .then(results => {
          resolve(results);
        }).catch(err => {
          reject(err);
        });
    });
  }

  checkPresenceFichier(performer: string, title: string): Promise<{subsonic: [], winmedia: []}> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.get<{subsonic: [], winmedia: []}>
    (this.serverEndpoint + '/api/checkPresenceFichier?performer=' + this.CF.escapeSpecialsURL(performer) + '&title=' + this.CF.escapeSpecialsURL(title),
      { headers }).toPromise();
  }

  sendValidatedFiles(dataFile: Musiques, dataMix: MusiquesMix, flag: string, proprietes: any, stations: any, user) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('dataFile', JSON.stringify(dataFile))
      .set('dataMix', JSON.stringify(dataMix))
      .set('flag', flag)
      .set('proprietes', JSON.stringify(proprietes))
      .set('stations', JSON.stringify(stations))
      .set('user', JSON.stringify(user));
    return new Promise((resolve, reject) => {
      this.http.post<any>(this.serverEndpoint + '/api/sendValidatedFiles',
        body.toString().replace(/\+/gi, '%2B'), {headers}).toPromise()
        .then(connection => {
          if (connection.error === 1) {
            reject('500 error server');
          } else {
            resolve(connection);
          }
        }).catch(err => {
          reject(err);
        });
    });
  }

  sendValidatedFilesSons(dataFile: Musiques, dataMix: MusiquesMix, categories: any, stations: any, user) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('dataFile', JSON.stringify(dataFile))
      .set('dataMix', JSON.stringify(dataMix))
      .set('categories', JSON.stringify(categories))
      .set('stations', JSON.stringify(stations))
      .set('user', JSON.stringify(user));
    return new Promise((resolve, reject) => {
      this.http.post<any>(this.serverEndpoint + '/api/sendValidatedFilesSons',
        body.toString().replace(/\+/gi, '%2B'), {headers}).toPromise()
        .then(connection => {
          if (connection.error === 1) {
            reject('500 error server');
          } else {
            resolve(connection);
          }
        }).catch(err => {
          reject(err);
        });
    });
  }
}
